import he from "he";
import sanitizeHtml from "sanitize-html";
import { getCategoryDetails } from "./";
import logger from "../../../../lib/logger";

const ALLOWED_TAGS = [
  "a",
  "img",
  "p",
  "span",
  "ul",
  "ol",
  "li",
  "strong",
  "em",
  "b",
  "i",
  "u",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6"
];

const ALLOWED_ATTRIBUTES = {
  a: ["href", "name", "target", "rel", "title"],
  img: ["src", "alt", "title"],
  p: ["class"],
  span: ["class"],
  ul: ["class"],
  ol: ["class"],
  li: ["class"]
};

export default state => {
  const footerHtmlEncoded =
    getCategoryDetails(state)?.footerHtmlEncoded || null;

  if (!footerHtmlEncoded || footerHtmlEncoded.length <= 1) {
    return null;
  }

  try {
    const decoded = he.decode(footerHtmlEncoded);

    return sanitizeHtml(decoded, {
      allowedTags: ALLOWED_TAGS,
      allowedAttributes: ALLOWED_ATTRIBUTES
    });
  } catch (error) {
    logger.error(error);

    return null;
  }
};
